var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityIconWht(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.43868 17C2.38749 17.0005 2.3368 16.9899 2.29006 16.969C2.24333 16.9481 2.20165 16.9174 2.1679 16.8789C2.13414 16.8404 2.10909 16.7951 2.09446 16.746C2.07983 16.697 2.07597 16.6453 2.08314 16.5947L3.09645 9.5335H1.37204C1.31485 9.53615 1.25787 9.52496 1.20593 9.50087C1.15399 9.47677 1.10864 9.4405 1.07373 9.39511C1.03882 9.34973 1.01539 9.29659 1.00543 9.24022C0.995462 9.18384 0.99926 9.12588 1.0165 9.07129L3.50533 1.24926C3.5288 1.17434 3.5764 1.10929 3.64072 1.06427C3.70504 1.01925 3.78245 0.996782 3.86087 1.00037H9.19408C9.25385 1.00022 9.31269 1.01515 9.36517 1.04376C9.41764 1.07237 9.46206 1.11376 9.49431 1.16408C9.52656 1.2144 9.5456 1.27205 9.54968 1.33168C9.55375 1.39131 9.54273 1.45101 9.51762 1.50525L7.26346 6.33358H8.83853C8.9023 6.33368 8.96487 6.35094 9.01969 6.38354C9.0745 6.41614 9.11953 6.46288 9.15007 6.51887C9.18061 6.57485 9.19553 6.63802 9.19326 6.70176C9.19099 6.76549 9.17163 6.82744 9.13719 6.88112L2.73734 16.8364C2.70522 16.8865 2.66105 16.9277 2.60887 16.9563C2.55669 16.9849 2.49817 16.9999 2.43868 17Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIconWht);
export default __webpack_public_path__ + "static/media/activity-icon-wht.40dcc9e87f6d23da3792fdaab8581cf1.svg";
export { ForwardRef as ReactComponent };